import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { MANUAL_JOURNAL_ENTRY_API } from "./apiRoutes";
import axiosAuth from "@/services/axiosAuth";

interface UseGetMJEParkedListProps {
  communityId: string,
  data: any;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getMJEParkedList = async (communityId: string, data: any) =>
  await axiosAuth.post(`${MANUAL_JOURNAL_ENTRY_API(communityId)}/parked/list`, data);

const useGetMJEParkedList = ({
  communityId,
  data,
  queryParams,
}: UseGetMJEParkedListProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["mje-parked-list"],
    queryFn: () => getMJEParkedList(communityId, data),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    retry: 2,
    ...queryParams,
    enabled: queryParams?.enabled,
  });
};

export default useGetMJEParkedList;
